import React, { forwardRef, ReactElement, useContext, useEffect, useLayoutEffect } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { ISubHeaderProps } from '../SubHeader/SubHeader';
import { IPageProps } from '../Page/Page';
import AuthContext from '../../contexts/authContext';
import { authPagesMenu } from '../../menu';

interface IPageWrapperProps {
  isProtected?: boolean;
  title?: string;
  description?: string;
  children: ReactElement<ISubHeaderProps>[] | ReactElement<IPageProps> | ReactElement<IPageProps>[];
  className?: string;
}
const PageWrapper = forwardRef<HTMLDivElement, IPageWrapperProps>(
  ({ isProtected = true, description, className, children }, ref) => {
    useLayoutEffect(() => {
      // 浏览器 Tab 标题固定为系统名称，不随页面变化
      // @ts-ignore
      document.getElementsByTagName('TITLE')[0].text = '会员标签系统';
      // @ts-ignore
      document
        ?.querySelector('meta[name="description"]')
        .setAttribute('content', description || process.env.REACT_APP_META_DESC || '');
    });

    const { user } = useContext(AuthContext);

    const navigate = useNavigate();
    useEffect(() => {
      if (isProtected && user === '') {
        navigate(`../${authPagesMenu.login.path}`);
      }
      return () => {};
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <div ref={ref} className={classNames('page-wrapper', 'container-fluid', className)}>
        {children}
      </div>
    );
  },
);
PageWrapper.displayName = 'PageWrapper';

export default PageWrapper;
